import React, { useState, useEffect } from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import {
  Space,
  SearchBar,
  Collapse,
  SpinLoading,
  ErrorBlock,
  AutoCenter,
} from 'antd-mobile';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
const webviewHttpHandler = new WebviewHttpHandler(true);

const CommonQuestion = () => {
  const [activeKeys, setActiveKeys] = useState([]);
  const [faqAllList, setFaqAllList] = useState([]);
  const [faqFilterList, setFaqFilterList] = useState([]);
  const [loading, setLoading] = useState(true);
  const getfaqList = () => {
    webviewHttpHandler.get('/questions/qa/list').then((res) => {
      if (res.success) {
        setFaqAllList(res.data);
        setFaqFilterList(res.data);
        setLoading(false);
      } else {
        console.error(res);
      }
    });
  };
  const handleSearch = (value) => {
    const newList = faqAllList.filter((faq) => {
      return faq.question.toLowerCase().includes(value.toLowerCase());
    });
    setFaqFilterList(newList);
  };
  useEffect(() => {
    getfaqList();
  }, []);
  return (
    <div className="main-container">
      <div className="text-align-center">
        <div className="heading font-bold">常見問題</div>
        <p className="text-body font-normal">
          您的問題，和運關心，<br></br>常見問題都可在這獲得解答喔！
        </p>
      </div>
      <Space block direction="vertical" style={{ '--gap': '16px' }}>
        <SearchBar
          className="custom-search-bar"
          placeholder="搜尋"
          showCancelButton
          style={{
            '--border-radius': '8px',
            '--background': '#ffffff',
            '--height': '48px',
            '--padding-left': '12px',
          }}
          onChange={(value) => handleSearch(value)}
          onCancel={(value) => handleSearch(value)}
        />
        {loading ? (
          <AutoCenter className="mt-8">
            <SpinLoading />
          </AutoCenter>
        ) : faqFilterList.length === 0 ? (
          <ErrorBlock
            status="empty"
            title={<>沒有常見問題</>}
            description={<></>}
          />
        ) : (
          faqFilterList.map(({ id, question, answer }) => (
            <div
              className="faq-container"
              style={{ whiteSpace: 'pre-wrap' }}
              key={id}>
              <Collapse
                onChange={(v) => {
                  if (v.length == 1) {
                    setActiveKeys([...activeKeys, id]);
                  } else {
                    setActiveKeys(activeKeys.filter((k) => k != id));
                  }
                }}>
                <Collapse.Panel
                  arrow={
                    <CaretDownOutlined
                      className={
                        activeKeys.filter((k) => k == id).length == 1
                          ? 'red'
                          : 'font-normal'
                      }
                    />
                  }
                  className="text-body font-semibold"
                  key={id}
                  title={
                    <div
                      className={
                        activeKeys.filter((k) => k == id).length == 1
                          ? 'red'
                          : ' '
                      }>
                      {question}
                    </div>
                  }>
                  <div className="text-body font-normal">{answer}</div>
                </Collapse.Panel>
              </Collapse>
            </div>
          ))
        )}
      </Space>
    </div>
  );
};

export default CommonQuestion;
